import {jwtServerInstance} from "../index";
import qs from	'qs'

//查询所有数据字典项
export const getAllShops = (taskTypeId) => {
    return jwtServerInstance.request({
        url:'/b2cshops/all',
        method:'post',
        data:qs.stringify({
            taskTypeId:taskTypeId
        })
    })
}


//查询所有数据字典项
export const getTaskRelaseShops = (taskTypeId) => {
    return jwtServerInstance.request({
        url:'/b2cshops/reshopall',
        method:'post',
        data:qs.stringify({
            taskTypeId:taskTypeId
        })
    })
}

//参数配置列表查询接口
export const getShops = ( queryform) => {
        return jwtServerInstance.request({
            url:'/b2cshops/query',
            method:'post',
            data:qs.stringify({
                shopNum:queryform.shopNum,
                shopName:queryform.shopName,
                shopUsername:queryform.shopUsername,
                shopType: queryform.shopType,
                shopMajorTypeId:queryform.shopMajorTypeId,
                status:queryform.status,
                shopGroup:queryform.shopGroup
            })
        })
    }

//更新sys_dict的一条数据记录
export const updateShop = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2cshops/update',
        method:'post',
        data:dialogForm
    })
}

//新增一条sys_dict数据记录
export const addShop = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2cshops/add',
        method:'post',
        data:dialogForm
    })
}

//删除一条sys_dict数据记录
export const deleteShop = (deleteId) => {
    return jwtServerInstance.request({
        url:'/b2cshops/delete',
        method:'post',
        data:qs.stringify({
            id:deleteId
        })
    })
}
